import type { Language } from './language';

export const LANGUAGES: readonly Language[] = ['kk', 'ru'];

/**
 * Language used when the URL carries none and the server has not said otherwise. The public site
 * has always served Kazakh at the root; `PublicSite.DefaultLanguage` overrides this once the
 * public settings have loaded.
 */
export const FALLBACK_LANGUAGE: Language = 'kk';

export function isLanguage(value: string | null | undefined): value is Language {
    return value !== null && value !== undefined && LANGUAGES.includes(value as Language);
}
